import { AGR_CAM_FIELDS_ITEM } from './agr-cam-fields.js'
import { AGR_CAM_TOPOGRAFIA_ITEM } from './agr-cam-topografia.js'
import { AGR_CAM_CLIMATOLOGIA_ITEM } from './agr-cam-climatologia.js'
import { AGR_CAM_SUELOS_ITEM } from './agr-cam-suelos.js'
import { AGR_CAM_AGUAS_ITEM } from './agr-cam-aguas.js'

/** @type {import('../help-index.js').HelpScreen} */
export const AGR_CAM_HELP = {
  screenId: 'agr-cam',
  label: 'Campos',
  navPath: 'Agro → Campos',
  keywords: [
    'agro', 'campo', 'campos', 'zona', 'lote', 'suelo', 'agua', 'clima',
    'climatología', 'análisis de suelo', 'análisis de agua', 'topografía',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Campos armás la base geográfica del establecimiento: campos y zonas, topografía, clima, suelos y aguas. Orden recomendado: primero «Campos», después topografía o análisis. Expandí cada tema para ver los pasos.',
  sidebarItems: [
    AGR_CAM_FIELDS_ITEM,
    AGR_CAM_TOPOGRAFIA_ITEM,
    AGR_CAM_CLIMATOLOGIA_ITEM,
    AGR_CAM_SUELOS_ITEM,
    AGR_CAM_AGUAS_ITEM,
  ],
}
